import type { Allocation, Case, Staff } from '../domain/types';
import { sum } from '../lib/safeMath';

const NO_ALLOCATIONS: readonly Allocation[] = [];

export const allocationsAt = (staff: Staff, month: number): readonly Allocation[] =>
  staff.byMonth[month] ?? NO_ALLOCATIONS;

/** その月の稼働率(%)。全案件の配分の合計。 */
export const loadOf = (staff: Staff, month: number): number =>
  sum(allocationsAt(staff, month).map((a) => a.percent));

/** その月の空き(%)。100% を超えている場合は 0。 */
export const capOf = (staff: Staff, month: number): number =>
  Math.max(0, 100 - loadOf(staff, month));

/** 案件期間(from〜endMonth)での空きの最小値(%)。 */
export const minCapOf = (staff: Staff, caseItem: Case, from = caseItem.startMonth): number => {
  let min = 100;
  for (let month = from; month <= caseItem.endMonth; month++) {
    min = Math.min(min, capOf(staff, month));
  }
  return min;
};

/** 担当案件数。既知の案件への配分だけを数える(部門業務や未知の案件 ID は数えない)。 */
export const caseCountOf = (
  staff: Staff,
  month: number,
  knownCaseIds: ReadonlySet<string>,
): number => allocationsAt(staff, month).filter((a) => knownCaseIds.has(a.caseId)).length;

/** 施工配置の対象(管理・支援を除く)。 */
export const deployStaff = (staff: readonly Staff[]): Staff[] =>
  staff.filter((s) => s.group !== 'mg');

export const usedAt = (staff: readonly Staff[], month: number): number =>
  sum(staff.map((s) => loadOf(s, month))) / 100;

export const spareAt = (staff: readonly Staff[], month: number): number =>
  sum(staff.map((s) => capOf(s, month))) / 100;
